//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
import {Permissions} from '@simpleforyou/coaching-shared';
//================= [VUE COMPONENTS] ==========================

export const moduleRoutes = [
  {
    path: i18n.global.t('routes.module.moduleList'),
    name: Routes.MODULE_LIST,
    component: () => import('@/components/module/ModuleList.vue'),
    meta: {
      title: i18n.global.t('titles.module.moduleList'),
      active: 'module',
      roles: [Permissions.ROLE_MODULE_INDEX],
    },
  },
  {
    path: i18n.global.t('routes.module.moduleEdit'),
    name: Routes.MODULE_EDIT,
    component: () => import('@/components/module/ModuleEdit.vue'),
    meta: {
      title: i18n.global.t('titles.module.moduleEdit'),
      active: 'module',
      roles: [Permissions.ROLE_MODULE_EDIT],
    },
  },
  {
    path: i18n.global.t('routes.module.modulePreview'),
    name: Routes.MODULE_PREVIEW,
    component: () => import('@/components/module/ModulePreview.vue'),
    meta: {
      title: i18n.global.t('titles.module.modulePreview'),
      active: 'module',
      roles: [Permissions.ROLE_MODULE_EDIT, Permissions.ROLE_MODULE_CREATE],
    },
  },
  {
    path: i18n.global.t('routes.module.moduleChapterStepShow'),
    name: Routes.MODULE_CHAPTER_STEP_MODULE_PREVIEW_SHOW,
    component: () => import('@/components/common/module/chapter/step/modulePreview/ModuleChapterStepModulePreviewShow.vue'),
    meta: {
      title: i18n.global.t('titles.module.moduleChapterStepShow'),
      active: 'module',
    },
  },
  {
    path: i18n.global.t('routes.module.moduleChapterStepCreate'),
    name: Routes.MODULE_CHAPTER_STEP_CREATE,
    component: () => import('@/components/module/chapter/step/ModuleChapterStepCreate.vue'),
    meta: {
      title: i18n.global.t('titles.module.moduleChapterStepCreate'),
      active: 'module',
      roles: [Permissions.ROLE_MODULE_EDIT, Permissions.ROLE_MODULE_CREATE],
    },
  },
  {
    path: i18n.global.t('routes.module.moduleChapterStepEdit'),
    name: Routes.MODULE_CHAPTER_STEP_EDIT,
    component: () => import('@/components/module/chapter/step/ModuleChapterStepEdit.vue'),
    meta: {
      title: i18n.global.t('titles.module.moduleChapterStepEdit'),
      active: 'module',
      roles: [Permissions.ROLE_MODULE_EDIT, Permissions.ROLE_MODULE_CREATE],
    },
  },
];
